export default "__VITE_ASSET__DzzLu9Qs__"